import styled from 'styled-components';

interface Props {
  transition: string;
}

/**
 * Styled container for the main page's vertical animation container.
 */
const VerticalAnimationContainer = styled.div<Props>`
  margin: 0;
  padding: 0;
  position: absolute;
  z-index: 1;
  transition: ${(props) => props.transition};
`;

export default VerticalAnimationContainer;
